// Module
import { DEFAULT_CURRENCY_CODE, Injector, LOCALE_ID, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { GlobalModule } from './global/global.module';
import { CoreModule } from './core/core.module';
import { BrowserModule, Title } from '@angular/platform-browser';
import { SharedModule } from './shared';
import de from '@angular/common/locales/de';
import { registerLocaleData } from '@angular/common';
// Component
import { AppComponent } from './app.component';
// Angular material
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// Angular fire
// Translate
import { I18nModule } from './i18n/i18n.module';
import { APP_DEFAULT_LANGUAGE } from '@global/constants';
import { TitleStrategy } from '@angular/router';
import { PageTitleStrategy } from './core/services/translate/PageTitleStrategy';
// Google Maps
import { GoogleMapsModule } from '@angular/google-maps';
import { MatDateFormats } from '@angular/material/core';
import { CUSTOM_DATEPICKER_FORMAT } from '@fwmovilidad/qb-home-ita-components-lib';

registerLocaleData(de);

@NgModule({
  declarations: [AppComponent],
  imports: [
    IonicModule.forRoot(),
    AppRoutingModule,
    BrowserModule,
    CoreModule,
    SharedModule,
    GlobalModule.forRoot(),
    I18nModule.forRoot({
      resources: [{ prefix: './assets/i18n/' }],
    }),
    BrowserAnimationsModule,
    GoogleMapsModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: LOCALE_ID, useValue: APP_DEFAULT_LANGUAGE },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    {
      provide: CUSTOM_DATEPICKER_FORMAT,
      useValue: {
        display: {
          dateInput: 'DD.MM.YYYY',
        },
      } as Partial<MatDateFormats>,
    },
    { provide: TitleStrategy, useClass: PageTitleStrategy },
  ],
})
export class AppModule {}
